export default function InitEventFilter() {
    const filterContainer = document.querySelector('.select-container');
    const monthSelect = document.getElementById('month-selector');

    if (!filterContainer)
        return;

    const selectElements = filterContainer.querySelectorAll('select');

    selectElements.forEach((select) => {
        select.addEventListener('change', () => {
            if (monthSelect) {
                if (select !== monthSelect && select.selectedIndex !== 0)
                    monthSelect.selectedIndex = 0;
            }

            select.form.submit();
        });
    });
}